import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SmallSpinner } from '../../utilities/spinner/Spinner'
//Bootstrap
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
//Redux
import { useSelector, useDispatch } from 'react-redux'
import { changePassword } from '../../redux'

function ChangePasswordButton(props) {
  const { email } = props
  const [openModal, setOpenModal] = useState(false)

  const ui = useSelector((state) => state.ui)

  const dispatch = useDispatch()

  return (
    <>
      <Button variant='outline-secondary' onClick={() => setOpenModal(true)}>
        Change Password
      </Button>
      <Modal show={openModal} backdrop={'static'}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Are you sure you want to change your password?</Modal.Title>
        </Modal.Header>
        <Modal.Body>A password reset verification will be sent to your registered email.</Modal.Body>
        <Modal.Footer>
          <Button variant='success' onClick={() => dispatch(changePassword(email, setOpenModal))} disabled={ui.loading}>
            <div>Yes{ui.loading && <SmallSpinner />}</div>
          </Button>
          <Button variant='danger' onClick={() => setOpenModal(false)} disabled={ui.loading}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

ChangePasswordButton.propTypes = {
  email: PropTypes.string.isRequired,
}

export default ChangePasswordButton
